module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Label":"Générer le rapport"}}')
  delete Component.options._Ctor
}
